mutation MarkThreadAsRead($threadId: ID!) {
    markThreadAsRead(threadId: $threadId) {
        id
        isUnread
    }
}
